export const GET_RESULTS_BEGIN = "GET_RESULTS_BEGIN"
export const GET_RESULTS_ERROR = "GET_RESULTS_ERROR"
export const GET_RESULTS_SUCCESS = "GET_RESULTS_SUCCESS"